module.exports = __webpack_public_path__ + "static/img/1020.e3dd199.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme2/totalBattery/1020.png
// module id = TQx+
// module chunks = 68